// AccessKeyModal.js
import React, { useState, useEffect } from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

const SettlementReportDatePickerModal = ({ open, settlementReportType, onCancel, onGenerate }) => {
  const [selectedValue, setSelectedValue] = useState(moment());
  const [isLoading, setIsLoading] = useState(false);

  // Reset the date when the modal opens to avoid confusion
  useEffect(() => {
    if (open) {
      console.log('settlementReportType: ',settlementReportType);
      setSelectedValue(moment());
    }
  }, [open]);

   const handleDisabledDate = (current) => {
    // `current` is the date being rendered in the calendar
    if (!current) {
      return false;
    }

    // Disable future dates based on the report type
    if (settlementReportType === "monthly") {
      return current > moment().endOf("month");
    }
    if (settlementReportType === "yearly") {
      return current > moment().endOf("year");
    }
    return false;
  };

  const handleOk = async () => {
    setIsLoading(true);
    try{
      await onGenerate(selectedValue);
    }catch{
      setIsLoading(false);
    }finally{
      setIsLoading(false);
    };
  }

  // Dynamically set the title based on the settlementReportType prop
  const modalTitle = `Select ${
    settlementReportType == "monthly" ? "Month" : "Year"
  } for Report`;

  return (
    <Modal
      title={modalTitle}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={isLoading}
    >
      <DatePicker
        value={selectedValue}
        onChange={(date) => setSelectedValue(date)}
        // The picker prop is now dynamic based on the settlementReportType!
        picker={settlementReportType == "monthly" ? "month" : "year"}
        style={{ width: "100%" }}
        disabledDate={handleDisabledDate}
      />
    </Modal>
  );
};

export default SettlementReportDatePickerModal;